/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zalo_Connection_BrokenInputs */

const vi_error_zalo_connection_broken = /** @type {(inputs: Error_Zalo_Connection_BrokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mất kết nối Zalo OA. Bấm "Kết nối lại" ở tab Kết nối.`)
};

/**

* @param {Error_Zalo_Connection_BrokenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zalo_connection_broken = /** @type {((inputs?: Error_Zalo_Connection_BrokenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zalo_Connection_BrokenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zalo_connection_broken(inputs)
});